import { useQuery } from '@tanstack/react-query';
import { FieldValues } from 'react-hook-form';

import { dictionaryMembershipOptions } from '@/module/Nomen/DictionaryMembership/model/DictionaryMembershipModel';

import { AsyncSelectControl, AsyncSelectControlProps } from '@/core/components';

type DictionaryMembershipSelectControlProps<T extends FieldValues> = Omit<
  AsyncSelectControlProps<T>,
  'isError' | 'isLoading' | 'options'
>;

export function DictionaryMembershipSelectControl<T extends FieldValues>(
  props: DictionaryMembershipSelectControlProps<T>,
) {
  const { data, isLoading, isError } = useQuery(dictionaryMembershipOptions.getAll());

  return (
    <AsyncSelectControl
      isError={isError}
      isLoading={isLoading}
      options={data ?? []}
      {...props}
    />
  );
}
